import CommisionPlan from './template_01';

const DefaultCommissionPlan=(props) =>{
    return (
        <CommisionPlan {...props}/>
    );
  }
  
  export default DefaultCommissionPlan;